export default "__VITE_ASSET__835567be__"